import type { GithubWebhookDelivery, GithubWebhookDeliveryStatus } from "../../api/types.js";

export function countDeliveryStatuses(items: readonly GithubWebhookDelivery[]): {
  processed: number;
  failed: number;
  received: number;
} {
  const counts = { processed: 0, failed: 0, received: 0 };
  for (const item of items) {
    if (item.status === "processed") counts.processed += 1;
    else if (item.status === "failed") counts.failed += 1;
    else counts.received += 1;
  }
  return counts;
}

export function deliveryHeadline(counts: {
  processed: number;
  failed: number;
  received: number;
}): string {
  const total = counts.processed + counts.failed + counts.received;
  if (total === 0) {
    return "No signed source-control receipts are stored. Empty is not a green merge gate.";
  }
  if (counts.failed > 0) {
    return `${counts.failed} receipt${counts.failed === 1 ? "" : "s"} failed intake. Failed is visible; it is not rewritten as success.`;
  }
  if (counts.received > 0) {
    return `${counts.received} receipt${counts.received === 1 ? "" : "s"} admitted but not yet processed.`;
  }
  return `${counts.processed} processed receipt${counts.processed === 1 ? "" : "s"}. Processing is not repository writeback.`;
}

export function deliveryStatusTone(
  status: GithubWebhookDeliveryStatus,
): "positive" | "critical" | "neutral" {
  if (status === "failed") return "critical";
  if (status === "processed") return "positive";
  return "neutral";
}
